'use client';
import { useSuspenseQuery } from '@tanstack/react-query';

import XImage from '@/components/@base/x-image';
import MultilayerFilterList from '@/components/app/archive/components/filter/@shared/items/category-filters/multilayer-filter-list';
import Props from '@/components/app/archive/components/filter/@shared/items/category-filters/type';
import { getFilterCategoryListOptions } from '@/components/app/archive/services/hooks';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { archive: archiveLocalization } = pageLevelLocalization;

export default function CategoryFilters({ initialFilters }: Props) {
  const { data } = useSuspenseQuery(getFilterCategoryListOptions());

  return (
    <>
      <IconTextCombo
        wrapperClassName='my-2'
        Icon={
          <XImage
            src={imagesList.icons.productCategories}
            alt={archiveLocalization.filter.productCategories}
          />
        }
        title={archiveLocalization.filter.productCategories}
        textClassName='text-bold text-base'
      />
      {data.length > 0 && (
        <MultilayerFilterList items={data} initialFilters={initialFilters} />
      )}
    </>
  );
}
